import { Button, Modal, message } from "antd";
import React, { useState } from "react";
import { TRACKING_BASE_URL } from "../../app.config";
import { fetchTrackingApp } from "./get-tracking-url.module";

export const GetTrackingUrl = (props) => {

    const {
        tripId
    } = props;

    const [isModalVisible, setModalVisible] = useState(false);
    const [trackingUrl, setTrackingUrl] = useState("");

    const showModal = () => {
        fetchTrackingApp(
            (trackingApp) => {
                setTrackingUrl(`${TRACKING_BASE_URL}/?tripId=${tripId}&app=${trackingApp}`);
                setModalVisible(true);
            },
            () => {
                message.error("Failed to get tracking URL");
            }
        );
    }

    const handleCancel = () => {
        setModalVisible(false);
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(trackingUrl)
            .then(() => message.success("Tracking URL copied"))
            .catch(() => message.error("Failed to copy tracking URL"));
    }

    return (
        <div>
            <Button
                onClick={showModal}
                className="bordered-btn send-driver-details-btn"
            >Get Tracking URL</Button>
            <Modal
                title={"Tracking URL"}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <div style={{ wordBreak: 'break-all', marginBottom: '12px' }}>
                    <a href={trackingUrl} target="_blank" rel="noopener noreferrer">{trackingUrl}</a>
                </div>
                <Button className="bordered-btn" onClick={handleCopy}>Copy URL</Button>
            </Modal>
        </div>
    )
}
